class DateHelper {
    static formatDate(dateStr: string, showHourMin: boolean = false): string {
        const date: Date = new Date(dateStr);
        const options: Intl.DateTimeFormatOptions = {
            weekday: undefined,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: showHourMin ? 'numeric' : undefined,
            minute: showHourMin ? 'numeric' : undefined,
        };

        return date.toLocaleDateString(undefined, options);
    };
};

export default DateHelper;
